const passwordRegex = new RegExp('^(?:(?=.*[a-z])(?:(?=.*[A-Z])(?=.*[\\d])(?=.*[\\^\\$\\*\\.\\[\\]\\{\\}\\(\\)\\?\\-\\&/\\\\,\\>\\<@#!%\'":;|_~]))).{8,}$');
const codeRegex = new RegExp(/^\d{6}$/);
const passwordLengthRegex = new RegExp(/^.{8,}$/);
const passwordLowerCaseRegex = new RegExp(/.*[a-z]/);
const passwordUpperCaseRegex = new RegExp(/.*[A-Z]/);
const passwordNumberCaseRegex = new RegExp(/.*[\d]/);
// eslint-disable-next-line no-useless-escape
const passwordCharacterRegex = new RegExp(/.*[\^\$\*\.\[\]\{\}\(\)\?\-\&\,\>\<\|\@\#\!\%\'\"\:\;\|\_\~]/);

export const passwordValidation = (password) => passwordRegex.test(password);
export const codeValidation = (code) => codeRegex.test(code);
export const passwordLengthValidation = (password) => passwordLengthRegex.test(password);
export const passwordLowerValidation = (password) => passwordLowerCaseRegex.test(password);
export const passwordUpperValidation = (password) => passwordUpperCaseRegex.test(password);
export const passwordNumberValidation = (password) => passwordNumberCaseRegex.test(password);
export const passwordCharacterValidation = (password) => passwordCharacterRegex.test(password);
